import apiRequest from './apiConfig';

const BASE_URL = 'https://uatedsbrapi.zenplus.in/private-attendance/api/v1/tenants';

export const getAllTenantsApi = () =>
  apiRequest({ method: 'get', url: BASE_URL });

export const addTenantApi = (payload) =>
  apiRequest({ method: 'post', url: BASE_URL, payload });

export const updateTenantApi = (id, payload) =>
  apiRequest({ method: 'put', url: `${BASE_URL}/${id}`, payload });

export const deleteTenantApi = (id) =>
  apiRequest({ method: 'delete', url: `${BASE_URL}/${id}` });
